module.exports = __webpack_public_path__ + "static/media/open-ai.190d0cfa.svg";